import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../hooks/useFetch";
import { App } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { SimpleDataTable } from "../../../ui/DataTable/SimpleDataTable";

export const Apps = () => {
  const { t } = useTranslation();
  // Получение данных и обновление их в сторе.
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/applications`);
  const [apps, setApps] = useState<App[]>();

  const [appId, setAppId] = useState("");
  const [pendingAppUpdate, setPendingAppUpdate] = useState<{ id: string; state: boolean } | null>(null);

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/applications/${appId}`
  );

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setApps(response.data as unknown as App[]);
    setLoading(false);
  }, [response]);

  useEffect(() => {
    if (!saveResponse) {
      return;
    }
    setPendingAppUpdate(null);
    doFetchItem();
  }, [saveResponse]);

  useEffect(() => {
    if (!pendingAppUpdate) return;

    setAppId(pendingAppUpdate.id);
  }, [pendingAppUpdate]);

  useEffect(() => {
    if (!pendingAppUpdate || appId !== pendingAppUpdate.id) return;

    doFetchItemSave({
      method: "PUT",
      data: {
        data: { enabled: pendingAppUpdate.state },
      },
    });
  }, [appId, pendingAppUpdate]);

  let nodes = apps?.map((data) => {
    return {
      id: data.id,
      name: data.attributes.name,
      description: data.attributes.description,
      depends_on: data.attributes.depends_on,
      enabled: data.attributes.enabled,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  

  const onItemEdit = (id: string, state: boolean) => {
    setLoading(true);
    setPendingAppUpdate({ id, state });
  };

  const columns: ColumnDef<any>[] = [
    {
      header: t("module"),
      size: 200,
      cell: ({ row }) => row.original.name,
    },
    {
      id: "action",
      size: 150,
      cell: ({ row }) =>
        row.original.enabled ? (
          <Button variant={"outline"} size={"datepicker"} className="w-full" onClick={() => onItemEdit(row.original.id, false)}>{t("disconnect")}</Button>
        ) : (
          <Button variant={"outline"} size={"datepicker"} className="w-full" onClick={() => onItemEdit(row.original.id, true)}>{t("connect")}</Button>
        ),
    },
  ];

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background px-6">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('apps')}</span>
        </div>
      </div>
      {!nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
        </div>
        ) : (
          <SimpleDataTable data={data.nodes} columns={columns}/>
        )}
    </div>
  );
};
